module.exports = __webpack_public_path__ + "static/media/baseMeme12.8ebb7a18.jpg";